import fallbackContent from '../../content/sanityContent.json';

export const useSanityContent = () => {
  return fallbackContent;
};
